import { render, staticRenderFns } from "./LotDetailsHeader.vue?vue&type=template&id=620fc4f2&scoped=true&"
import script from "./LotDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./LotDetailsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620fc4f2",
  null
  
)

export default component.exports